export const GeminiIcon = (props: JSX.IntrinsicElements['svg']) => {
  return (
    <svg width='15' height='15' viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M7.5 15C7.5 13.9625 7.30002 12.9875 6.9 12.075C6.51252 11.1625 5.98125 10.3687 5.30625 9.69375C4.63125 9.01875 3.8375 8.48748 2.925 8.1C2.0125 7.69998 1.0375 7.5 0 7.5C1.0375 7.5 2.0125 7.30623 2.925 6.91875C3.8375 6.51873 4.63125 5.98125 5.30625 5.30625C5.98125 4.63125 6.51252 3.8375 6.9 2.925C7.30002 2.0125 7.5 1.0375 7.5 0C7.5 1.0375 7.69377 2.0125 8.08125 2.925C8.48127 3.8375 9.01875 4.63125 9.69375 5.30625C10.3687 5.98125 11.1625 6.51873 12.075 6.91875C12.9875 7.30623 13.9625 7.5 15 7.5C13.9625 7.5 12.9875 7.69998 12.075 8.1C11.1625 8.48748 10.3687 9.01875 9.69375 9.69375C9.01875 10.3687 8.48127 11.1625 8.08125 12.075C7.69377 12.9875 7.5 13.9625 7.5 15Z'
        fill='url(#paint0_radial_555_74342)'
      />
      <defs>
        <radialGradient
          id='paint0_radial_555_74342'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(1.48862 6.09616) rotate(18.6832) scale(15.9656 127.895)'
        >
          <stop offset='0.0671246' stopColor='#9168C0' stopOpacity={1} />
          <stop offset='0.342551' stopColor='#5684D1' stopOpacity={1} />
          <stop offset='0.672076' stopColor='#1BA1E3' stopOpacity={1} />
        </radialGradient>
      </defs>
    </svg>
  );
};
